module.exports = __webpack_public_path__ + "static/media/ios-trash.ae5afe7d.svg";